<div class="cargo-information-container">
  <div class="wrapper">
    <div class="firstItem">
      <h1>Информация о грузе</h1>
      <div class="commonCargoInfo">
        <div class="firstItem_firstRow">
          <el-form-item style="flex: 1" label="Вид груза" prop="cargoInformation.typeOfCargo">
            <el-select value-key="id" @change="handleChangeTypeOfCargo" style="width: 100%" v-model="dataForm.cargoInformation.typeOfCargo" placeholder="Выберите вариант">
              <el-option v-for="typeOfCargo in typeOfCargos" :key="typeOfCargo.id" :label="typeOfCargo.title" :value="typeOfCargo" />
            </el-select>
          </el-form-item>

          <el-form-item style="flex: 3" label="Характер груза" prop="cargoInformation.natureOfCargo">
            <el-select @change="handleNatureCargoChange" filterable value-key="id" style="width: 100%" v-model="dataForm.cargoInformation.natureOfCargo" placeholder="Выберите вариант">
              <el-option v-for="cargoNature in cargoNatures" :key="cargoNature.id" :label="cargoNature.title" :value="cargoNature" />
            </el-select>
          </el-form-item>

          <el-form-item style="flex: 2" label="Объявленная стоимость груза" prop="cargoInformation.cargoCost">
            <el-input style="width: 100%" type="number" v-model="dataForm.cargoInformation.cargoCost" min="0" @change="handleChangeCargoCost" />
          </el-form-item>
        </div>

        <div class="commonInfoWrapper">
          <div :class="{commonInfoWrapper_firstItem: true, cylinderCustom: dataForm.cargoInformation.typeOfCargo.id === 2 }">
            <el-form-item label="Кол-во мест" prop="cargoInformation.numberOfIdenticalLoads">
              <el-input class="inputAppend" v-model="dataForm.cargoInformation.numberOfIdenticalLoads" min="1" type="number" @change="checkNumberOfIdenticalLoads">
                <template #append>шт.</template>
              </el-input>
            </el-form-item>
            <el-form-item v-if="dataForm.cargoInformation.typeOfCargo.id !== 3" prop="cargoInformation.cargoWeight">
              <template #label>Общая масса<span class="hidden-pc">, кг</span></template>
              <el-input class="inputAppend" min="1" type="number" v-model="dataForm.cargoInformation.cargoWeight" @change="handleChangeCargoParams($event, 'weight')">
                <template #append>кг</template>
              </el-input>
              <div class="total-weight--error" v-if="checkDayToDay(dataForm.applicationCargoPickup.pickupDate) && checkCity()">
                День в день до
                <span v-if="!checkHour()">12:00, больше</span>
                <span v-else>15:00, меньше</span>
                30кг
              </div>
            </el-form-item>
          </div>
          <div class="dimensionsWrapperMain">
            <el-form-item v-if="dataForm.cargoInformation.typeOfCargo.id === 1" class="dimensionsWrapper" label="Габариты груза, см" prop="cargoInformation.cargoDimensions">
              <el-form-item prop="cargoInformation.length">
                <el-input type="number" placeholder="Д" v-model="dataForm.cargoInformation.cargoDimensions.length" min="10" @change="handleChangeCargoParams($event, 'length')"> </el-input>
              </el-form-item>

              <div>х</div>

              <el-form-item>
                <el-input type="number" placeholder="Ш" v-model="dataForm.cargoInformation.cargoDimensions.width" min="10" @change="handleChangeCargoParams($event, 'width')"> </el-input>
              </el-form-item>

              <div>х</div>

              <el-form-item>
                <el-input type="number" placeholder="В" v-model="dataForm.cargoInformation.cargoDimensions.height" min="10" @change="handleChangeCargoParams($event, 'height')"> </el-input>
              </el-form-item>
            </el-form-item>
            <el-form-item class="volumeCommon removePaddingRight" v-if="dataForm.cargoInformation.typeOfCargo.id === 1" label="Общий объём">
              <div class="volumeCommon_number">{{dataForm.cargoInformation.cargoVolume}}</div>
              <div style="margin-left: auto">м³</div>
            </el-form-item>
          </div>

          <el-form-item class="dimensionsWrapper" v-if="dataForm.cargoInformation.typeOfCargo.id === 2" label="Габариты груза, см" prop="cargoInformation.cargoDimensions">
            <el-form-item>
              <el-input type="number" placeholder="В" v-model="dataForm.cargoInformation.sizeOfCargoCylinder.height" min="10" @change="handleChangeCargoParams($event, 'height')"> </el-input>
            </el-form-item>

            <div>х</div>

            <el-form-item>
              <el-input type="number" placeholder="Д" v-model="dataForm.cargoInformation.sizeOfCargoCylinder.diameter" min="10" @change="handleChangeCargoParams($event, 'diameter')"> </el-input>
            </el-form-item>
          </el-form-item>
        </div>
      </div>

      <template v-if="dataForm.thirdPerson.cargoTransportationCustomer === 'Отправитель'">
        <div style="width: 100%; display: flex; justify-content: space-between; align-items: center">
          <el-form-item style="margin-bottom: 5px" prop="cargoInformation.cashOnDelivery">
            <el-switch
              v-model="dataForm.cargoInformation.cashOnDelivery"
              active-text="Наложенный платёж"
              :disabled="dataForm.cargoInformation.cargoRedemption"
              @change="(value) => toggleResetFields(value, ['cargoInformation.cashOnDeliverySum'])"
            />
          </el-form-item>
          <el-form-item style="margin-bottom: 5px" class="removePaddingRight" label="Сумма наложенного платежа" prop="cargoInformation.cashOnDeliverySum">
            <el-input type="number" v-model="dataForm.cargoInformation.cashOnDeliverySum" :disabled="!dataForm.cargoInformation.cashOnDelivery" />
          </el-form-item>
        </div>
      </template>
      <template v-if="dataForm.thirdPerson.cargoTransportationCustomer === 'Получатель'">
        <div style="width: 100%; display: flex; justify-content: space-between; align-items: center">
          <el-form-item style="align-self: flex-start; margin-top: 5px" prop="cargoInformation.cargoRedemption">
            <el-switch
              v-model="dataForm.cargoInformation.cargoRedemption"
              active-text="Выкуп груза"
              :disabled="dataForm.cargoInformation.cashOnDelivery"
              @change="(value) => toggleResetFields(value, ['cargoInformation.whoPaysTheRansom', 'cargoInformation.cargoRedemptionSum'])"
            />
          </el-form-item>
          <div>
            <el-form-item label="За чей счёт" prop="cargoInformation.whoPaysTheRansom">
              <el-select
                v-model="dataForm.cargoInformation.whoPaysTheRansom"
                placeholder="Выберите вариант"
                :disabled="!dataForm.cargoInformation.cargoRedemption"
                @change="checkRedemption('whoPaysTheRansom')"
              >
                <el-option
                  v-for="option in optionsWhoPaysTheRansom"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value"
                  :disabled="dataForm.sender.cityFrom !== 'Челябинск' && option.label === 'За счет ТК ЛУЧ'"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="Сумма выкупа груза" prop="cargoInformation.cargoRedemptionSum">
              <el-input
                type="number"
                v-model="dataForm.cargoInformation.cargoRedemptionSum"
                :disabled="!dataForm.cargoInformation.cargoRedemption"
                min="0"
                :max="dataForm.cargoInformation.whoPaysTheRansom === '1' ? '6000' : ''"
                @change="checkRedemption('cargoRedemptionSum')"
              />
            </el-form-item>
          </div>
        </div>
      </template>
      <el-form-item prop="cargoInformation.returnOfDocuments">
        <el-switch v-model="dataForm.cargoInformation.returnOfDocuments" active-text="Возврат документов" />
      </el-form-item>
    </div>

    <div class="secondItem">
      <!-- <el-form-item prop="cargoInformation.typeOfPackaging" label="Обязательная доп. упаковка">
        <ExtraPackagingList :options="dataForm.getRequiredExtraPackaging" v-model:extraPackaging="dataForm.cargoInformation.typeOfPackaging" />
      </el-form-item> -->
      <el-form-item prop="cargoInformation.typeOfPackaging" label="Доступная доп. упаковка">
        <ExtraPackagingList :options="dataForm.fetchedExtraPackaging" v-model:extraPackaging="dataForm.cargoInformation.typeOfPackaging" />
      </el-form-item>

      <!-- <div style="margin-right: 5px">
        <el-form-item prop="cargoInformation.whoPaysForCargoExtraPacking" label="Плательщик за доп. упаковку">
          <el-radio-group @change="handleChangePayer('cargoExtraPacking', $event)" class="radioGroupButtonsDefault" v-model="dataForm.cargoInformation.whoPaysForCargoExtraPacking">
            <el-radio-button label="Отправитель" value="Отправитель" />
            <el-radio-button label="Получатель" value="Получатель" />
            <el-radio-button label="Третье лицо" :disabled="!dataForm.getThirdPersonAvailable" value="Третье лицо" />
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="cargoInformation.typeOfPaymentForCargoExtraPacking" label="Способ оплаты">
          <el-radio-group @change="handleChangeTypeOfPayment('cargoExtraPacking', $event)" class="radioGroupButtonsDefault" v-model="dataForm.cargoInformation.typeOfPaymentForCargoExtraPacking">
            <el-radio-button label="Наличные" value="Наличные" />
            <el-radio-button label="Расчётный счет юр. лица" value="Счет" />
          </el-radio-group>
        </el-form-item>
      </div> -->
    </div>
  </div>

  <div class="bord_button">
    <el-form-item>
      <el-button class="button_send" type="primary" @click="$emit('click-button-back')"> Назад </el-button>
    </el-form-item>
    <el-form-item>
      <el-button class="button_send" type="primary" @click="$emit('click-button-next', [...getArrayOfRules(dataForm.cargoInformation, 'cargoInformation')])"> Далее </el-button>
    </el-form-item>
  </div>
  <el-dialog v-model="dialogBadDimensionsInfo.open" title="Уважаемый клиент!" class="dialog" center>
    <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; gap: 8px">
      <div>Максимально допустимые габариты для городов превышены.</div>
      <div class="dialogContent_wrapper">
        <div v-if="citiesRestrictions.cityFrom">
          <div style="font-size: 1rem">{{citiesRestrictions.cityFrom.title}}:</div>
          <div :class="{redText: citiesRestrictions.cityFrom.maxAcceptanceShippingHeight === dialogBadDimensionsInfo.maxHeight}">
            -Макс. высота: {{citiesRestrictions.cityFrom.maxAcceptanceShippingHeight / 100}} м.
          </div>
          <div :class="{redText: citiesRestrictions.cityFrom.maxAcceptanceShippingWeight === dialogBadDimensionsInfo.maxWeight}">
            -Макс. вес: {{citiesRestrictions.cityFrom.maxAcceptanceShippingWeight}} кг.
          </div>
          <div :class="{redText: citiesRestrictions.cityFrom.maxAcceptanceShippingSize === dialogBadDimensionsInfo.maxSize}">
            -Макс. длина/ширина: {{citiesRestrictions.cityFrom.maxAcceptanceShippingSize / 100}} м.
          </div>
        </div>
        <div v-if="citiesRestrictions.cityTo">
          <div style="font-size: 1rem">{{citiesRestrictions.cityTo.title}}:</div>
          <div :class="{redText: citiesRestrictions.cityTo.maxAcceptanceShippingHeight === dialogBadDimensionsInfo.maxHeight}">
            -Макс. высота: {{citiesRestrictions.cityTo.maxAcceptanceShippingHeight / 100}} м.
          </div>
          <div :class="{redText: citiesRestrictions.cityTo.maxAcceptanceShippingWeight === dialogBadDimensionsInfo.maxWeight}">
            -Макс. вес: {{citiesRestrictions.cityTo.maxAcceptanceShippingWeight}} кг.
          </div>
          <div :class="{redText: citiesRestrictions.cityTo.maxAcceptanceShippingSize === dialogBadDimensionsInfo.maxSize}">
            -Макс. длина/ширина: {{citiesRestrictions.cityTo.maxAcceptanceShippingSize / 100}} м.
          </div>
        </div>
      </div>
      <div>Свяжитесь, пожалуйста, с менеджером по телефону:</div>
      <div style="margin-top: '15px'">
        <a style="color: #0000ee; text-decoration: underline" href="tel:89222382000">89222382000</a>
      </div>
      <div>Или по email:</div>
      <div style="margin-top: '15px'">
        <a style="color: #0000ee; text-decoration: underline" href="mailto:logist@tk-luch.ru">logist@tk-luch.ru</a>
      </div>
    </div>
  </el-dialog>
</div>
